import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Dimmer, Icon, Loader, Popup } from 'semantic-ui-react';
import { crearMensaje } from './crearMensaje';
import history from '../../../utils/history';
import { usuarioLogueado } from '../../../utils/loggedInfo';
import useSocket from '../../../utils/useSocket';
import { useApolloClient, useLazyQuery, useMutation } from '@apollo/client';
import { OBTENER_PAGINADO_NOTIFICACIONES } from '../../../graphql/queries/notificaciones';
import {
  ELIMINAR_NOTIFICACION,
  MARCAR_NOTIFICACION_LEIDA,
} from '../../../graphql/mutations/notificaciones';
import { OBTENER_PROSPECTO_PORID_NOTIFICACIONES } from '../../../graphql/queries/prospectos';
import { useLocation } from 'react-router-dom';
import './styles.css';
import { OBTENER_EVENTO_POR_ID } from '../../../graphql/queries/eventos';
import { OBTENER_DESARROLLO_PORID } from '../../../graphql/queries/desarrollos';
import { OBTENER_COTIZACION_PORID } from '../../../graphql/queries/cotizaciones';
import { OBTENER_ORDEN_VENTA_POR_ID } from '../../../graphql/queries/ordenesVentas';
import { OBTENER_ACTIVIDAD_POR_ID } from '../../../graphql/queries/actividades';
import { OBTENER_DATO_FISCAL_POR_PROSPECTOID } from '../../../graphql/queries/datosFiscales';

const NotificacionIcon = ({ totalItems, refetch }) => {
  const { idLogin, rol } = usuarioLogueado();
  const apollo = useApolloClient();
  const { webSocketActivo, mensaje, setMensaje } = useSocket(idLogin);
  const [activo, setActivo] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [listaNotificaciones, setListaNotificaciones] = useState([]);
  const [totalNotificaciones, setTotalNotificaciones] = useState(0);
  const [loading, setLoading] = useState(false);

  const [marcarNotificacionLeida] = useMutation(MARCAR_NOTIFICACION_LEIDA);
  const [eliminarNotificacion] = useMutation(ELIMINAR_NOTIFICACION);
  const location = useLocation();

  const onEliminarNotificacion = async (id) => {
    setLoading(true);
    await eliminarNotificacion({
      variables: {
        notificacionId: id,
      },
    });
    obtenerPaginadoNotificaciones();
    refetch();
  };

  const onActionClick = async (
    tipoNotificacion,
    notificacionId,
    notificacionData
  ) => {
    setLoading(true);
    await marcarNotificacionLeida({
      variables: {
        notificacionId: notificacionId,
      },
    });

    obtenerPaginadoNotificaciones();
    refetch();

    document.body.click();
    switch (tipoNotificacion) {
      case 'ASIGNO_PROSPECTO_A_VENDEDOR_INTERO': {
        const result = await apollo.query({
          query: OBTENER_PROSPECTO_PORID_NOTIFICACIONES,
          variables: { id: notificacionData.prospectoId },
        });

        const prospecto =
          result.data.prospectos.obtenerProspectoPorIdNotificaciones;

        if (window.location.pathname.includes('/crm/prospectos/detalle')) {
          const state = { ...location.state };
          delete state.data;
          state.data = prospecto;
          history.replace({ ...location, state });
          return window.location.reload();
        } else {
          return history.push('/crm/prospectos/detalle', {
            data: prospecto,
            titulo: 'Detalle Prospecto',
            tipoMovimiento: 'editar',
            tipo: 'PROSPECTO',
          });
        }
      }

      case 'REGISTRO_EVENTO_CON_PARTICIPANTES': {
        const result = await apollo.query({
          query: OBTENER_EVENTO_POR_ID,
          variables: { id: notificacionData.eventoId },
        });

        const evento = result.data.eventos.obtenerPorId;

        if (
          window.location.pathname.includes('/administracion/eventos/detalle')
        ) {
          const state = { ...location.state };
          delete state.data;
          state.data = evento;
          state.titulo = 'Detalle Evento ' + evento.folio;
          history.replace({ ...location, state });
          return window.location.reload();
        } else {
          return history.push('/administracion/eventos/detalle', {
            data: evento,
            titulo: 'Detalle Evento ' + evento.folio,
          });
        }
      }

      case 'PROSPECTO_SIN_VALORACION': {
        const result = await apollo.query({
          query: OBTENER_PROSPECTO_PORID_NOTIFICACIONES,
          variables: { id: notificacionData.prospectoId },
        });

        const prospecto =
          result.data.prospectos.obtenerProspectoPorIdNotificaciones;

        if (window.location.pathname.includes('/crm/prospectos/detalle')) {
          const state = { ...location.state };
          delete state.data;
          state.data = prospecto;
          history.replace({ ...location, state });
          return window.location.reload();
        } else {
          return history.push('/crm/prospectos/detalle', {
            data: prospecto,
            titulo: 'Detalle Prospecto',
            tipoMovimiento: 'editar',
            tipo: 'PROSPECTO',
          });
        }
      }

      case 'SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_TRES_ESTRELLAS':
        return navegarAgregarActividad(notificacionData.prospectoId);
      case 'SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_DOS_ESTRELLAS':
        return navegarAgregarActividad(notificacionData.prospectoId);
      case 'SIN_ACTIVIDAD_PROGRAMADA_PROSPECTO_UNA_ESTRELLAS':
        return navegarAgregarActividad(notificacionData.prospectoId);

      // Calendario - Actividades
      case 'REGISTRO_ACTIVIDAD_INTERNA':
        return navegarACalendario(notificacionData.actividadId);

      case 'REGISTRO_ACTIVIDAD_PROSPECTO':
        return navegarACalendario(notificacionData.actividadId);

      case 'VENDEDOR_EDITO_ACTIVIDAD_REGISTRADA':
        return navegarACalendario(notificacionData.actividadId);

      case 'LLEGO_FECHA_HORA_ACTIVADAD':
        return navegarACalendario(notificacionData.actividadId);

      case 'RECORDATORIO_ACTIVIDAD':
        return navegarACalendario(notificacionData.actividadId);

      /// Desarrollos
      case 'APROBO_DESARROLLO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'APROBO_PRODUCTO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'RECHAZO_DESARROLLO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'RECHAZO_PRODUCTO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'VENDEDOR_AGREGO_PRODUCTOS_A_DESARROLLO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'VENDEDOR_CANCELO_DESARROLLO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'ADMINISTRADOR_CANCELO_DESARROLLO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      case 'DESARROLLO_HA_FINALIZADO':
        return navegarADesarrollo(notificacionData.desarrolloId);

      //// Cotizaciones
      case 'VENDEDOR_REGISTRO_COTIZACION':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'VENDEDOR_CANCELO_COTIZACION':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'COTIZACION_ESTA_POR_VENCER_DIEZ_DIAS':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'COTIZACION_ESTA_POR_VENCER_CINCO_DIAS':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'COTIZACION_ESTA_POR_VENCER_UN_DIA':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'COTIZACION_HA_VENCIDO':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'ADMINISTRADOR_CANCELO_COTIZACION':
        return navegarACotizacion(notificacionData.cotizacionId);

      case 'CREA_ORDEN_VENTA':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, false);

      case 'VENDEDOR_CANCELA_ORDEN_VENTA':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, false);

      case 'ADMINISTRADOR_CANCELA_ORDEN_VENTA':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, false);

      case 'FACTURACION_CAMBIA_A_FACTURADA_ORDEN_VENTA':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, false);

      case 'FACTURACION_SOLICITA_SALIDA_ORDEN_VENTA_ALMACEN':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, true);

      case 'ORDEN_VENTA_ESTATUS_ENTREGADO_O_PARCIAL':
        return navegarAOrdenVenta(notificacionData.ordenVentaId, false, false);

      case 'CLIENTE_SIN_ACTIVIDAD_REGISTRADA_POR_MAS_DE_TREINTA_DIAS': {
        const result = await apollo.query({
          query: OBTENER_DATO_FISCAL_POR_PROSPECTOID,
          variables: { prospectoId: notificacionData.prospectoId },
        });

        const cliente =
          result.data.datosFiscales.obtenerDatosFiscalesPorProspectoId;

        return history.push('/crm/prospectos/seguimiento/', {
          tipo: 'CLIENTE',
          prospectoId: cliente.prospecto.id,
          nombreProspecto: cliente.razonSocial,
          prospecto: cliente.prospecto,
          ocupacion: cliente.prospecto.ocupacion,
          cultivos: cliente.prospecto.listaCultivos
            .map((x) => {
              return x.cultivo.nombre;
            })
            .join(', '),
          calificacion: cliente.prospecto.calificacion,
          evento: cliente.prospecto.evento && cliente.prospecto.evento.nombre,
        });
      }

      case 'GUARDA_FOLIO_FACTURA_DE_ORDEN_VENTA_PAGO_CONTADO': {
        const result = await apollo.query({
          query: OBTENER_ORDEN_VENTA_POR_ID,
          variables: { id: notificacionData.ordenVentaId },
        });

        const data = result.data.ordenesVentas.obtenerPorId;

        return history.push('facturacion/form/agregarFactura', {
          title: 'AGREGAR FACTURA',
          factura: data,
          modal: true,
          tipoMovimiento: 'editar',
        });
      }
      case 'GUARDA_FOLIO_FACTURA_DE_ORDEN_VENTA_PAGO_CREDITO': {
        const result = await apollo.query({
          query: OBTENER_ORDEN_VENTA_POR_ID,
          variables: { id: notificacionData.ordenVentaId },
        });

        const data = result.data.ordenesVentas.obtenerPorId;

        return history.push('facturacion/form/agregarFactura', {
          title: 'AGREGAR FACTURA',
          factura: data,
          modal: true,
          tipoMovimiento: 'editar',
        });
      }

      case 'FECHA_PAGO_FACTURA_HA_VENCIDO':
        return; // Action Pendiente
      case 'ORDEN_VENTA_CAMBIA_ESTATUS_A_FACTURACION':
        return; // Action Pendiente

      case 'ADMINISTRADOR_INACTIVA_PROSPECTO': {
        const result = await apollo.query({
          query: OBTENER_PROSPECTO_PORID_NOTIFICACIONES,
          variables: { id: notificacionData.prospectoId },
        });

        const prospecto =
          result.data.prospectos.obtenerProspectoPorIdNotificaciones;

        if (window.location.pathname.includes('/crm/prospectos/detalle')) {
          const state = { ...location.state };
          delete state.data;
          state.data = prospecto;
          history.replace({ ...location, state });
          return window.location.reload();
        } else {
          return history.push('/crm/prospectos/detalle', {
            data: prospecto,
            titulo: 'Detalle Prospecto',
            tipoMovimiento: 'editar',
            tipo: 'PROSPECTO',
          });
        }
      }

      case 'VENDEDOR_INACTIVA_PROSPECTO': {
        const result = await apollo.query({
          query: OBTENER_PROSPECTO_PORID_NOTIFICACIONES,
          variables: { id: notificacionData.prospectoId },
        });

        const prospecto =
          result.data.prospectos.obtenerProspectoPorIdNotificaciones;

        if (window.location.pathname.includes('/crm/prospectos/detalle')) {
          const state = { ...location.state };
          delete state.data;
          state.data = prospecto;
          history.replace({ ...location, state });
          return window.location.reload();
        } else {
          return history.push('/crm/prospectos/detalle', {
            data: prospecto,
            titulo: 'Detalle Prospecto',
            tipoMovimiento: 'editar',
            tipo: 'PROSPECTO',
          });
        }
      }
      default:
    }
  };

  const navegarAgregarActividad = async (prospectoId) => {
    const result = await apollo.query({
      query: OBTENER_PROSPECTO_PORID_NOTIFICACIONES,
      variables: { id: prospectoId },
    });
    const prospecto =
      result.data.prospectos.obtenerProspectoPorIdNotificaciones;
    return history.push('/crm/actividades', {
      prospecto: prospecto,
    });
  };
  const navegarACotizacion = async (cotizacionId) => {
    const result = await apollo.query({
      query: OBTENER_COTIZACION_PORID,
      variables: { id: cotizacionId },
    });

    const cotizacion = result.data.cotizaciones.obtenerPorIdAsync;

    if (
      window.location.pathname.includes('/crm/prospectos/seguimiento/nuevo/')
    ) {
      const state = { ...location.state };
      delete state.data;
      delete state.prospectoId;
      state.data = cotizacion;
      state.prospectoId = cotizacion.prospecto.id;
      history.replace({ ...location, state });
      return window.location.reload();
    } else {
      return history.push('/crm/prospectos/seguimiento/nuevo/', {
        data: {
          ...cotizacion,
          direccionId: cotizacion.direccion
            ? cotizacion.direccion.id
            : cotizacion.direccionLab,
          cultivoId: cotizacion.cotizacionCultivos.map((x) => {
            return x.cultivoId;
          }),
        },
        prospectoId: cotizacion.prospecto.id,
        titulo: 'Detalle de la cotización',
      });
    }
  };

  const navegarADesarrollo = async (desarrolloId) => {
    const result = await apollo.query({
      query: OBTENER_DESARROLLO_PORID,
      variables: { id: desarrolloId },
    });

    const desarrollo = result.data.desarrollos.obtenerDesarrolloPorId;

    if (
      window.location.pathname.includes('/crm/prospectos/seguimiento/nuevo/')
    ) {
      const state = { ...location.state };
      delete state.data;
      delete state.prospectoId;
      state.data = desarrollo;
      state.prospectoId = desarrollo.prospecto.id;
      history.replace({ ...location, state });
      return window.location.reload();
    } else {
      return history.push('/crm/prospectos/seguimiento/nuevo/', {
        data: desarrollo,
        prospectoId: desarrollo.prospecto.id,
        titulo: 'Detalle del Desarrollo',
      });
    }
  };

  const navegarAOrdenVenta = async (ordenVentaId, isFactura, isSalida) => {
    const result = await apollo.query({
      query: OBTENER_ORDEN_VENTA_POR_ID,
      variables: { id: ordenVentaId },
    });

    const values = result.data.ordenesVentas.obtenerPorId;

    const model = {
      folio: values.folio,
      id: values.id,
      fechaFactura: values.fechaFactura,
      fechaPago: values.fechaPago,
      direccionLab: values.direccionLab,
      folioFactura: values.folioFactura,
      esPublicoGeneral: values.esPublicoGeneral,
      ordenCompra: values.ordenCompra,
      inventarioId: values.inventarioId,
      correoFacturacion: values.correoFacturacion,
      comentarios: values.comentarios,
      fechaEntrega: values.fechaEntrega,
      fechaCreacion: values.fechaCreacion,
      direccionEnvioId: values.direccionEnvioId,
      direccionEnvio: values.direccionEnvio,
      contactoId: values.contactoId,
      lote: values.lote,
      geolocalizacion: values.geolocalizacion,
      ordenVentaProductos: values.ordenVentaProductos,
      documento: values.documento && {
        key: values.documento.key,
        name: values.documento.nombreArchivo,
        contentType: values.documento.contentType,
        urldoc: values.documento.url,
      },
    };

    if (window.location.pathname.includes('/ventas/ordenes-ventas/detalle')) {
      const state = { ...location.state };
      delete state.model;
      state.model = model;
      history.replace({ ...location, state });
      return window.location.reload();
    } else {
      return history.push('/ventas/ordenes-ventas/detalle', {
        model: model,
        cotizacion: values.cotizacion,
        desarrollo: values.desarrollo,
        isCotizacion: values.cotizacion === null ? false : true,
        isDesarrollo: values.desarrollo === null ? false : true,
        isDetalle: true,
        isFactura: isFactura,
        isSalidaProducto: isSalida,
      });
    }
  };

  const navegarACalendario = async (actividadId) => {
    const result = await apollo.query({
      query: OBTENER_ACTIVIDAD_POR_ID,
      variables: { id: actividadId },
    });

    const actividad = result.data.actividades.obtenerActividadPorId;

    if (window.location.pathname.includes('/crm/prospectos/detalle')) {
      const state = { ...location.state };
      delete state.actividadId;
      state.actividadId = actividad.id;
      history.replace({ ...location, state });
      return window.location.reload();
    } else {
      return history.push('/crm/calendario', {
        actividadId: actividad.id,
      });
    }
  };

  useEffect(() => {
    if (listaNotificaciones.length === 0) {
      setLoading(true);
      obtenerPaginadoNotificaciones();
    }
    
  }, []);

  useEffect(() => {
    if (mensaje === 'RefreshNotifications') {
      setLoading(true);
      refetch();
      obtenerPaginadoNotificaciones();
      setMensaje(null);
    }
    
  }, [mensaje]);

  useEffect(() => {
    setLoading(true);
    obtenerPaginadoNotificaciones();
    
  }, [activo, pagina]);

  const [obtenerPaginadoNotificaciones] = useLazyQuery(
    OBTENER_PAGINADO_NOTIFICACIONES,
    {
      variables: {
        pagina: pagina,
        activo: activo,
      },
      onCompleted: (res) => {
        setLoading(false);
        setListaNotificaciones(res.notificaciones.obtenerNotificaciones);
        setTotalNotificaciones(res.notificaciones.obtenerNumNotificaciones);
      },
      onError: (err) => {
        console.log(err.message);
      },
    }
  );

  return (
    <>
      <Popup
        wide
        on={'click'}
        onClose={() => {
          setActivo(true);
        }}
        trigger={
          <div className='notificacion_container_icon'>
            <Icon name='bell'></Icon>
            <span
              style={{
                color: 'white',
                fontFamily: 'futuramedium',
                fontSize: '1vw',
              }}
            >
              {totalItems}
            </span>
          </div>
        }
        position='bottom right'
      >
        <div style={{ width: '25vw', height: '40vw' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                flex: 1,
                marginTop: '1vw',
                marginLeft: '0.3vw',
                marginRight: '1vw',
                marginBottom: '0.5vw',
              }}
            >
              <label
                style={{
                  fontSize: '1.8vw',
                  fontFamily: 'futuraextra_black',
                  textAlign: 'center',
                }}
              >
                NOTIFICACIONES
              </label>
              {/* <hr /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              textAlign: 'right',
            }}
          >
            {activo && (
              <div
                style={{
                  flex: 1,
                  marginBottom: '1vw',
                  marginRight: '1vw',
                }}
              >
                <span
                  style={{
                    cursor: 'pointer',
                    color: '#80BC00',
                  }}
                  onClick={() => setActivo(false)}
                >
                  Ver Leídas
                </span>
              </div>
            )}

            {!activo && (
              <div
                style={{
                  flex: 1,
                  marginBottom: '1vw',
                  marginRight: '1vw',
                }}
              >
                <span
                  style={{
                    cursor: 'pointer',
                    color: '#80BC00',
                  }}
                  onClick={() => setActivo(true)}
                >
                  Ver Nuevas
                </span>
              </div>
            )}
          </div>
          {/*  */}
          <div
            style={{
              flex: 1,
              height: '32vw',
              overflowY: listaNotificaciones.length > 0 ? 'scroll' : 'hidden',
              msOverflowStyle: 'scrollbar',
            }}
          >
            {loading && (
              <Dimmer active inverted>
                <Loader inverted>Cargando</Loader>
              </Dimmer>
            )}
            {listaNotificaciones.length > 0 ? (
              <>
                {listaNotificaciones.map((noti) => {
                  return (
                    <Card
                      style={{
                        width: '95%',
                        height: 'auto',
                        marginLeft: '0.4vw',
                        marginTop: '0.2vw',
                      }}
                    >
                      <Card.Description
                        className={
                          activo ? 'notificacion-mensaje' : 'notificacion-leida'
                        }
                        style={{ height: '100%' }}
                      >
                        {crearMensaje(
                          noti.id,
                          noti.tipoNotificacion,
                          noti.data,
                          noti.fechaCreacion,
                          onActionClick,
                          onEliminarNotificacion,
                          activo
                        )}
                      </Card.Description>
                    </Card>
                  );
                })}
              </>
            ) : (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <label style={{ fontSize: '1vw', marginTop: '2vw' }}>
                  No hay notificaciones
                </label>
              </div>
            )}
          </div>
          {listaNotificaciones.length > 0 &&
            listaNotificaciones.length < totalNotificaciones && (
              <div
                style={{
                  flex: 1,
                  textAlign: 'center',
                  marginBottom: '1vw',
                  marginRight: '1vw',
                  marginTop: '1vw',
                }}
              >
                <span
                  style={{
                    cursor: 'pointer',
                    color: '#80BC00',
                  }}
                  onClick={() => setPagina(pagina + 1)}
                >
                  Ver Mas
                </span>
              </div>
            )}
        </div>
      </Popup>
    </>
  );
};

NotificacionIcon.propTypes = {
  items: PropTypes.array,
  refetch: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default NotificacionIcon;
